import { render } from "./DraftSwapMain.vue?vue&type=template&id=66e00da8&scoped=true"
import script from "./DraftSwapMain.vue?vue&type=script&lang=js"
export * from "./DraftSwapMain.vue?vue&type=script&lang=js"

import "./DraftSwapMain.vue?vue&type=style&index=0&id=66e00da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e00da8"]])

export default __exports__